module.exports = __webpack_public_path__ + "img/58b45f6.jpg";